import { Component, ComponentInterface, h, Host, JSX } from '@stencil/core';

/**
 * @slot - wb-spinner or wb-round-button element
 */
@Component({
  tag: 'wb-input-action',
  styleUrl: 'input-action.scss',
  shadow: true,
})
export class InputAction implements ComponentInterface {
  public render(): JSX.Element {
    return (
      <Host class="wb-input-action">
        <slot />
      </Host>
    );
  }
}
